const HeroSecondary = `
<dys-block>
  <dys-row background-color="#F5774E">
    <dys-column>
      <dys-text
        color="#FFFFFF"
        font-size="36px"
        editable="h1"
        font-family="'Droid Sans', 'Helvetica Neue', Arial, sans-serif"
        align="center"
      >
        New Features
      </dys-text>
      <dys-img
        width="130px"
        src="https://assets.opensourceemails.com/imgs/neopolitan/speedometer.png"
        editable="img"
        align="center"
      />
      <dys-text
        font-size="16px"
        color="#933F24"
        editable="content"
        font-family="'Droid Sans', 'Helvetica Neue', Arial, sans-serif"
        align="center"
        line-height="20px"
      >
        Faster download speeds for all users! <br />
        If speed is what you need, we‘ve got you covered!
      </dys-text>
      <dys-button
        background-color="#AC4D2F"
        href="https://example.com"
        editable="button"
        font-family="'Droid Sans', 'Helvetica Neue', Arial, sans-serif"
        font-weight="bold"
        font-size="16px"
        line-height="30px"
        width="200px"
        border-radius="4px"
        align="center"
      >
        Learn More
      </dys-button>
    </dys-column>
  </dys-row>
</dys-block>
`;

export default HeroSecondary;
